import type { ItemsDataHook } from "@/features/integrations/shared/renderer/hooks/types";

export type ItemsDataHookGetter = (
  clientId?: string
) => ItemsDataHook | undefined;

const itemsDataHooksRegistry = new Map<string, ItemsDataHookGetter>();

export function registerCampaignsItemsDataHook(
  integrationName: string,
  getter: ItemsDataHookGetter
): void {
  itemsDataHooksRegistry.set(integrationName.toLowerCase(), getter);
}

export function getCampaignsItemsDataHook(
  integrationName: string | undefined,
  clientId?: string
): ItemsDataHook | undefined {
  if (!integrationName) return undefined;
  const getter = itemsDataHooksRegistry.get(integrationName.toLowerCase());
  return getter?.(clientId);
}
